@switch (type()) {
<!-- Used in product detail page: -->
@case ('withThumbnail') {
<div [class.invisible]="!shouldRenderCarousel()">
  <div class="keen-slider main_slider" #sliderMainProductRef (mouseenter)="showText = true"
    (mouseleave)="showText = false">

    @for (item of items(); track item) {
    <div class="keen-slider__slide number-slide">
      <img (error)="handleImageError($event)" [src]="item" alt="Image of product" />
    </div>
    }

    @if (showWhatsInsideButton()) {
    <div class="whats-inside">
      <button type="button" class="rolling-info" [class.active]="showText || this.resolutionService.isMobile()"
        (click)="whatsInside($event)">
        <i class="rolling-info-icon fas fa-info-circle"></i>
        <span class="rolling-info__text">
          What's inside
        </span>
      </button>
    </div>
    }

    <!-- Discount -->
    @if (showSaleTag()) {
    <div class="sale-badge">
      <span class="material-symbols-outlined">
        percent
      </span>
    </div>
    }

    <!-- Purchase Limit -->
    @if (purchaseLimit()) {
    <div class="card-action-labels-bottom">
      <span class="limited-to">{{purchaseLimit()}} Max</span>
      <span class="material-symbols-outlined">production_quantity_limits</span>
    </div>
    }


  </div>
  @if (showMultipleImages()) {
  <div class="keen-slider thumbnail_slider" #thumbnailRef>
    @for (item of items(); track item) {
    <div class="keen-slider__slide number-slide">
      <img (error)="handleImageError($event)" [src]="item" />
    </div>
    }
  </div>
  }
</div>
}
<!-- Producer products carousel in the producers view: -->
@case ('producerProduct') {
<div class="navigation-wrapper">
  <div #sliderRef class="keen-slider">
    @if (items().length) {
    @for (item of items(); track item.content.productDetails.id) {
    <div class="keen-slider__slide">
      <app-product-card-v2 [cardResume]="item?.content"></app-product-card-v2>
    </div>
    } @if (hasMoreItems()) {
    <div class="keen-slider__slide is-view-more" [routerLink]="['/shop/bakery']"
      (click)="this.producersService.setName()">
      <div class="product-card">
        <h4 class="h6-semibold">View more</h4>
      </div>
    </div>
    }
    }
  </div>
  <svg class="arrow arrow--left" (click)="slider.prev()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
  </svg>
  <svg class="arrow arrow--right" (click)="slider.next()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
  </svg>
</div>
}
<!-- Default carousel. Used for suggested product in the order -->
@default () {
<div class="navigation-wrapper">
  <div #sliderRef class="keen-slider">
    @if (items().length) {
    @for (item of items(); track (item.content.productDetails.variantId || item.content.productDetails.id)) {
    <div class="keen-slider__slide">
      @switch (item?.contentType) {
      @case ('image') {
      <img (error)="handleImageError($event)" [src]="item.content" alt="carousel-image" />
      } @default () {
      @let productDetails = getProductDetail(item?.content.productDetails);
      <app-product-card-v2 [cardResume]="{settings: {}, productDetails: productDetails}"
        [isFromBlog]="!!item.isFromBlog" #carouselProductCard></app-product-card-v2>
      }
      }
    </div>
    }
    }
  </div>

  <svg class="arrow arrow--left" (click)="slider.prev()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
  </svg>
  <svg class="arrow arrow--right" (click)="slider.next()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
  </svg>
</div>
}
}